<section class="vh-75">
  <div class="container py-5 h-100">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col col-xl-10">
          <div class="row g-0">
            <div class="col-md-6 col-lg-5 d-none d-md-block">
              <img
                src="../../../assets/imgs/login-img.png"
                alt="login form"
                class="img-fluid" style="border-radius: 1rem 0 0 1rem;"
              />
            </div>
            <div class="col-md-6 col-lg-7 d-flex align-items-center">
              <div class="card-body p-4 p-lg-5 text-black">

                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">

                  <div class="d-flex align-items-center mb-3 pb-1">
                    <span class="h1 fw-bold mb-0">Welcome :)</span>
                  </div>
          
                  <h5 class="fw-normal mb-3 pb-3" style="letter-spacing: 1px;">
                    To use our product, please login using your email and password or your google account
                  </h5>

                  <div class="form-outline mb-4">
                    <mat-form-field class="full-width-input">
                      <input matInput type="email" placeholder="Email Address" formControlName="emailAddress" required>
                      <mat-error *ngIf="isFieldInvalid('emailAddress')">
                        Oh my, something is wrong with your email...please check that is correct.
                      </mat-error>
                    </mat-form-field>
                    <label class="form-label">Email address</label>
                  </div>

                  <div class="form-outline mb-4">
                    <mat-form-field class="full-width-input">
                      <input matInput type="password" placeholder="Password" formControlName="password" required>
                      <mat-error *ngIf="isFieldInvalid('password')">
                        Looks like you made a mistake in your password
                      </mat-error>
                    </mat-form-field>
                    <label class="form-label">Password</label>
                  </div>

                  <div class="pt-1 mb-4">
                    <button mat-raised-button class="block btn-blue-royal" color="primary">Login</button>
                    
                  </div>

                  <div class="pt-1 mb-4">
                    <button mat-raised-button class="block btn-blue-royal" color="red" (click)="SignInGoogleAuth()">
                      <i class="fab fa-google-plus-g"></i>
                      Log in with Google
                    </button>
                  </div>
                  <a class="small text-muted" routerLink="/forgot-password">Forgot password?</a>
                  <p class="mb-5 pb-lg-2 txt-blue">Don't have an account? <a class="txt-blue "routerLink="/register-user">Register here</a></p>
                  
                </form>

              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</section>












  